import NoSsr from '@common/noSsr';
import Button from '@components/common/button';
import { InterviewPracticeStepCode } from '@domain/constant/interviewPracticeStep';
import { WebcamStatus } from '@domain/constant/webcamTypes';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { CommonCard } from '../../common/card';
import Webcam from '../../common/webcam/Webcam';
import styles from './recordTime.module.scss';

const cx = classNames.bind(styles);

export const RecordTime = () => {
  const practiceQuestionInfo = useInterviewPracticeStore((state) => state.practiceQuestionInfo, shallow);
  const recorderService = useInterviewPracticeStore((state) => state.recorderService, shallow);
  const micScale = useInterviewPracticeStore((state) => state.micScale);
  const timer = useInterviewPracticeStore((state) => state.timer, shallow);
  const policies = useInterviewPracticeStore((state) => state.policies);
  const restartedQuestionSnList = useInterviewPracticeStore((state) => state.restartedQuestionSnList);
  const getIsRestarted = useInterviewPracticeStore((state) => state.getIsRestarted);
  const startRecording = useInterviewPracticeStore((state) => state.startRecording);
  const saveRecord = useInterviewPracticeStore((state) => state.saveRecord);
  const stopRecording = useInterviewPracticeStore((state) => state.stopRecording);
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const currentPracticeIndex = useInterviewPracticeStore(
    (state) => state.practiceStepInfo.currentPracticeIndex,
    shallow,
  );
  const setStep = useInterviewPracticeStore((state) => state.practiceStepInfo.setStep, shallow);
  const [enabled, setEnabled] = useState(true);

  const currentQuestion = () => practiceQuestionInfo.practiceQuestions[currentPracticeIndex];

  useEffect(() => {
    (async () => {
      await startRecording();
      saveRecord(currentQuestion().practiceQuestionSn);

      setEnabled(false);
      setTimeout(() => toNextStep(), 500);
    })();
  }, []);

  const handleClickEnd = async () => {
    await stopRecording();
    await saveRecord(currentQuestion().practiceQuestionSn);

    setEnabled(false);
    setTimeout(() => toNextStep(), 500);
  };

  const handleClickRestart = async () => {
    await stopRecording();
    restartedQuestionSnList.push(currentQuestion().practiceQuestionSn);

    setEnabled(false);
    setTimeout(() => setStep(InterviewPracticeStepCode.PRACTICE_THINK), 500);
  };

  // 20초 경과 후 답변 제출 가능
  const savable = timer.increasingTime >= policies.minAnswerTimeSec;

  // 한번 다시 시작하기 누르면 다시는 다시 시작할 수 없음
  const restartButtonDisabled = getIsRestarted(currentQuestion()?.practiceQuestionSn);

  return (
    <CommonCard className={cx('card', { enabled: true })}>
      <div className={cx('question')}>
        <span className={cx('emphasis')}>Q{currentPracticeIndex + 1}.</span> {currentQuestion()?.questionText}
      </div>
      <NoSsr>
        <Webcam
          className={cx('webcam')}
          stream={recorderService.recorder?.stream ?? null}
          initialized={recorderService.recorder !== null}
          videoRecording={recorderService.status === WebcamStatus.ACTIVE}
          micActive={micScale > 10}
          leftTime={timer.decreasingTime}
        />
      </NoSsr>
      <div className={cx('footer')}>
        <Button
          theme="secondary"
          onClick={handleClickRestart}
          disabled={restartButtonDisabled || savable}
          styles={{
            width: 168,
            height: 48,
          }}
        >
          다시 하기
        </Button>
        <Button
          onClick={handleClickEnd}
          disabled={!savable}
          styles={{
            width: 168,
            height: 48,
          }}
        >
          답변 제출
        </Button>
      </div>
    </CommonCard>
  );
};
